import {Component, OnInit, ViewEncapsulation, ViewChild, Input, AfterViewInit} from '@angular/core';
import {BusinessRulesService} from "../../../core/business-rules/business-rules.service";
import {FormBuilder, NgForm, Validators, FormGroup, FormControl} from "@angular/forms";
import * as _ from 'lodash';
import * as moment from 'moment';
import {MessageService} from "primeng/components/common/messageservice";

@Component({
  selector: 'progol-time-limit',
  templateUrl: 'progol-time-limit.component.html',
  styleUrls: ['progol-time-limit.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProgolTimeLimitComponent implements OnInit, AfterViewInit {

  progolLimitTime: FormGroup;

  poolsInfo: any[] = [];

  sortSelected: any;

  _game;

  loading: boolean = false;

  asesors: any[] = [];

  /*@Input()
  drawName: string = '';*/

  @Input()
  set drawName(value) {
    this._game = value;
    setTimeout(x => {
      this.getActiveFootballPools();
    });
  }

  constructor(private formBuilder: FormBuilder, private businessService: BusinessRulesService, private messageService: MessageService) {

  }

  ngOnInit() {
    /* setTimeout(x => {
       //console.log('en setTimeout');
       this.setValues();
     });*/
    this.initProgolForm();
    //this.getActiveFootballPools();
  }


  selectedSort(event) {
    this.sortSelected = _.find(this.poolsInfo, sort => {
      return sort.id.drawNumber == event;
    });
    this.initProgolForm();
  }

  private getActiveFootballPools() {
    return this.businessService.getActiveFootballPools(this._game)
      .subscribe(
        response => {
          console.log('se concluyo la respuesta ', response);
          this.poolsInfo = response;
          //          this.mretroGameInfo = response;
        },
        error => {
          console.error(error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error
          });
        });
  }

  ngAfterViewInit() {

  }

  private initProgolForm() {
    let starPeriodBuying: Date;
    let endPeriodBuying: Date;
    let starPeriodGames: Date;
    let endPeriodGames: Date;
    let drawDate: Date;
    let message = '';
    if (this.sortSelected) {
      let date = moment(this.sortSelected.salesStartPeriod);
      if (this.sortSelected.salesStartPeriod != null) {
        starPeriodBuying = new Date();
        starPeriodBuying.setFullYear(parseInt(date.format('YYYY')));
        starPeriodBuying.setMonth(parseInt(date.format('MM')) - 1);
        starPeriodBuying.setDate(parseInt(date.format('DD')));
        starPeriodBuying.setHours(parseInt(date.format('HH')));
        starPeriodBuying.setMinutes(parseInt(date.format('mm')));
      }
      if (this.sortSelected.salesEndPeriod != null) {
        date = moment(this.sortSelected.salesEndPeriod);
        endPeriodBuying = new Date(); //moment(model.salesEndPeriod);
        endPeriodBuying.setFullYear(parseInt(date.format('YYYY')));
        endPeriodBuying.setMonth(parseInt(date.format('MM')) - 1);
        endPeriodBuying.setDate(parseInt(date.format('DD')));
        endPeriodBuying.setHours(parseInt(date.format('HH')));
        endPeriodBuying.setMinutes(parseInt(date.format('mm')));
      }
      if (this.sortSelected.startMatchesPeriod != null) {
        date = moment(this.sortSelected.startMatchesPeriod);
        starPeriodGames = new Date(); //moment(model.startMatchesPeriod);
        starPeriodGames.setFullYear(parseInt(date.format('YYYY')));
        starPeriodGames.setMonth(parseInt(date.format('MM')) - 1);
        starPeriodGames.setDate(parseInt(date.format('DD')));
        starPeriodGames.setHours(parseInt(date.format('HH')));
        starPeriodGames.setMinutes(parseInt(date.format('mm')));
      }
      if (this.sortSelected.endMatchesPeriod != null) {
        date = moment(this.sortSelected.endMatchesPeriod);
        endPeriodGames = new Date(); //moment(model.endMatchesPeriod);
        endPeriodGames.setFullYear(parseInt(date.format('YYYY')));
        endPeriodGames.setMonth(parseInt(date.format('MM')) - 1);
        endPeriodGames.setDate(parseInt(date.format('DD')));
        endPeriodGames.setHours(parseInt(date.format('HH')));
        endPeriodGames.setMinutes(parseInt(date.format('mm')));
      }
      if (this.sortSelected.drawDate != null) {
        date = moment(this.sortSelected.drawDate);
        drawDate = new Date(); //moment(model.endMatchesPeriod);
        drawDate.setFullYear(parseInt(date.format('YYYY')));
        drawDate.setMonth(parseInt(date.format('MM')) - 1);
        drawDate.setDate(parseInt(date.format('DD')));

      }
      message = this.sortSelected.message
    }
    this.progolLimitTime = this.formBuilder.group({
      drawDate: [drawDate, Validators.required],
      message: [message],
      buyingPeriod: this.formBuilder.group({
        starDate: [starPeriodBuying, Validators.required],
        starTime: [starPeriodBuying, Validators.required],
        endDate: [endPeriodBuying, Validators.required],
        endTime: [endPeriodBuying, Validators.required]
      }),
      periodGames: this.formBuilder.group({
        starDate: [starPeriodGames, Validators.required],
        starTime: [starPeriodGames, Validators.required],
        endDate: [endPeriodGames, Validators.required],
        endTime: [endPeriodGames, Validators.required]
      })
    });
  }

  onSubmitComunLimitTime() {

    if (this.progolLimitTime.valid) {
      console.log(moment(this.progolLimitTime.get('periodGames.endDate').value).format());
      const date =
        moment(this.progolLimitTime.get('periodGames.endTime').value).format('HH:mm');
      this.sortSelected.endMatchesPeriod = moment(this.progolLimitTime.get('periodGames.endDate').value).format('YYYY-MM-DD') + 'T' + moment(this.progolLimitTime.get('periodGames.endTime').value).format('HH:mm:ssZ');
      this.sortSelected.startMatchesPeriod = moment(this.progolLimitTime.get('periodGames.starDate').value).format('YYYY-MM-DD') + 'T' + moment(this.progolLimitTime.get('periodGames.starTime').value).format('HH:mm:ssZ');
      this.sortSelected.salesEndPeriod = moment(this.progolLimitTime.get('buyingPeriod.endDate').value).format('YYYY-MM-DD') + 'T' + moment(this.progolLimitTime.get('buyingPeriod.endTime').value).format('HH:mm:ssZ');
      this.sortSelected.salesStartPeriod = moment(this.progolLimitTime.get('buyingPeriod.starDate').value).format('YYYY-MM-DD') + 'T' + moment(this.progolLimitTime.get('buyingPeriod.starTime').value).format('HH:mm:ssZ');
      this.sortSelected.drawDate = moment(this.progolLimitTime.get('drawDate').value).format();
      this.sortSelected.message = this.progolLimitTime.get('message').value;

      this.businessService.sendProgolPeriods(this._game, this.sortSelected)
        .subscribe(
          response => {
            this.messageService.add({
              severity: 'success',
              summary: '',
              detail: 'La actualizacion fue satisfactoria.'
            });
          },
          error => {
            console.error(error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error
            });
          });
      console.log(this.sortSelected);
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: '',
        detail: 'Es necesario introducir toda la información.'
      });
    }
  }

  progolTeams(isRevancha): any[] {
    const teams: any[] = [];
    this.sortSelected.progolFootballTeams.forEach(t => {
      if (t.progolRevancha == isRevancha) {
        teams.push(t);
      }
    });
    return teams;
  }

  updateTeams() {
    console.log(this.sortSelected.progolFootballTeams);
    const body = this.sortSelected.progolFootballTeams.map(team => {
      // "progolFootballTeams":[{"progolFootballTeamId":4245,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":1,"localName":"AGUILAS","visitorName":"MAZATLAN","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4246,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":2,"localName":"QUERETARO","visitorName":"TOLUCA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4247,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":3,"localName":"PACHUCA","visitorName":"SAN LUIS","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4248,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":4,"localName":"TAPATIO","visitorName":"MORELIA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4249,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":5,"localName":"TAMPICO ","visitorName":"MERIDA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4250,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":6,"localName":"TLAXCALA","visitorName":"CELAYA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4251,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":7,"localName":"UCRANIA","visitorName":"SUIZA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4252,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":8,"localName":"ALEMANIA","visitorName":"ESPANA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4253,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":9,"localName":"BULGARIA","visitorName":"REP.IRLANDA","progolRevancha":false,"lastUpdate":1598561241000}]}]
      return {
        progolFootballTeamId: team.progolFootballTeamId,
        progolFootballPoolsFK: {drawNumber: team.drawNumber, progolGameName: team.progolGameName},
        eventNumber: team.eventNumber,
        localName: team.localName,
        visitorName: team.visitorName,
        progolRevancha: team.progolRevancha
      };
    });
    this.loading = true;
    this.businessService.updateFootballTeamsForProgols(this._game, body)
      .subscribe(response => {
        console.log("Se ha actualizado la informacion", response);
        this.sortSelected.progolFootballTeams = response.map(team => {
          // "progolFootballTeams":[{"progolFootballTeamId":4245,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":1,"localName":"AGUILAS","visitorName":"MAZATLAN","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4246,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":2,"localName":"QUERETARO","visitorName":"TOLUCA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4247,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":3,"localName":"PACHUCA","visitorName":"SAN LUIS","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4248,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":4,"localName":"TAPATIO","visitorName":"MORELIA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4249,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":5,"localName":"TAMPICO ","visitorName":"MERIDA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4250,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":6,"localName":"TLAXCALA","visitorName":"CELAYA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4251,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":7,"localName":"UCRANIA","visitorName":"SUIZA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4252,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":8,"localName":"ALEMANIA","visitorName":"ESPANA","progolRevancha":false,"lastUpdate":1598561241000},{"progolFootballTeamId":4253,"drawNumber":496,"progolGameName":"ProgolMediaSemana","eventNumber":9,"localName":"BULGARIA","visitorName":"REP.IRLANDA","progolRevancha":false,"lastUpdate":1598561241000}]}]
          return {
            progolFootballTeamId: team.progolFootballTeamId,
            drawNumber: team.progolFootballPoolsFK.drawNumber,
            progolGameName: team.progolFootballPoolsFK.progolGameName,
            eventNumber: team.eventNumber,
            localName: team.localName,
            visitorName: team.visitorName,
            progolRevancha: team.progolRevancha
          };
        });
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: 'Se actualizaron los casilleros correctamente'
        });
        this.loading = false;
      }, error => {
        console.error("Algo salio mal al actualizar la informacion", error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
        this.loading = false;
      });
  }


  /*private initComunLimitTime() {
    if (this.comunLimitTime !== undefined) {
      this.comunLimitTime.reset();
    }
    this.comunLimitTime = this.formBuilder.group({
      starSales: ['00:01', Validators.required],
      endSales: ['21:15', Validators.required],
    });

  }
  private setValues() {
    this.comunLimitTime.patchValue({
      starSales: this._game ? this._game.starSales : '',
      endSales: this._game ? this._game.endSales : ''
    });
    //console.log('mostramos el game', this.comunLimitTime.value);
  }
  onSubmitComunLimitTime() {

  }
*/
}




// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/businessRules/progol-time-limit/progol-time-limit.component.ts